<div *ngIf="audio?.link" (click)="onAudioPlayerClick($event)">
  <!-- <div class="text-xl text-gray-600 font-bold mb-3">
    Audio Tour
  </div> -->
  <div>
    <div *ngIf="audio.link" class="w-full mobile:w-full relative z-10">
      <audio [src]="audio.link" controls class="w-full max-w-[500px]" (click)="onAudioPlayerClick($event)"></audio>
    </div>
    <div *ngIf="audio.description" class="w-full mt-4 ml-2 mobile:w-full mobile:text-sm {{textColor}}" (click)="onAudioPlayerClick($event)">
      <p>{{ audio.description }}</p>
    </div>
  </div>
</div>